import { useExploreData } from "src/queries/hooks/knowledgeExplore";
import { ENTITY_LABELS_FETCH_LIMIT } from "../ExploreTab.consts";
import { toOption, useEntityRefFields } from "./useEntityRefFields.hook";

const useEntityLabels = ({ entityType, pkFieldName, labelFieldName, version, defaultLanguage, enabled }) => {
  const refFields = useEntityRefFields({ entityType, pkFieldName, labelFieldName, version });
  const { entityVersion, pkField, labelField, selectedFields } = refFields;

  const dataQuery = useExploreData({
    schemaType: entityType,
    version: entityVersion,
    fields: selectedFields,
    filters: [],
    pagination: { offset: 0, limit: ENTITY_LABELS_FETCH_LIMIT },
    enabled
  });

  const items = dataQuery.data?.[entityType]?.items ?? [];
  const options = items.map((item) => toOption(item, pkField, labelField, defaultLanguage));

  return { options, isLoading: (Boolean(enabled) && refFields.isLoading) || dataQuery.isLoading };
};

export default useEntityLabels;
